import dayjs from "dayjs"

import {
    productLoadStatusTypes,
    customInjectionFields as productInjectionFields,
} from "../schema/items/productSchema"

import {
    customInjectionFields as itemInjectionFields
} from "../schema/items/itemSchema"

import {
    customInjectionFields as containerInjectionFields
} from "../schema/repositories/containerSchema"

// import { getUpdateFieldValuesPayload } from "../../../hooks/api/useInjectionFields"

export const getUniqueItemCode = ({ courierTrackingNo, productId }) => {

    let uniqueId = dayjs().unix()

    return `${courierTrackingNo}_${productId}_${uniqueId}`
}

export const createProductInjectionFieldsPayload = ({
    productId,
    data,
    barcode,
    locationId,
    locationDisplay,
    mainData,
    targetInjectionFieldIds = [], // only update the id
    skipTargetInjectionFieldIds = [], // skip to update the id
    loadStatus = "",
    loadContainerId = "",
    loadContainerDateTime = "",
    nfcInfo = {},
    sourceProductRemId = '',
    schedulerRequests = {}
}) => {

    // console.log('data', data)

    let itemFields = []

    Object.keys(productInjectionFields).forEach(i => {

        let item = productInjectionFields[i]

        let _def = {
            refId: productId,
        }

        let val = '';

        if (i === `customerMarking`) {
            val = mainData?.marking
        }
        if (i === `customerBranchId`) {
            val = mainData?.userBranchId
        }
        if (i === `customerUserId`) {
            val = mainData?.userId
        }
        if (i === `isSplit`) {
            val = mainData?.isSplit
        }
        if (i === `splitFromRemId`) {
            val = mainData?.splitFromRemId
        }

        if (i === `lastUpdateDatetime`) {
            val = mainData?.lastUpdateDatetime
        }
        if (i === `lastUpdateUserId`) {
            val = mainData?.lastUpdateUserId
        }
        if (i === `lastUpdateUserDisplay`) {
            val = mainData?.lastUpdateUserDisplay
        }

        let dataInput = data?.input

        if (i === `supplierName`) {
            val = dataInput?.supplierName
        }
        if (i === `supplierContact`) {
            val = dataInput?.supplierContact
        }
        if (i === `courierTrackingNo`) {
            val = dataInput?.courierTrackingNo
        }
        if (i === `prepayDepositFee`) {
            val = dataInput?.prepaidDepositAmount
        }
        if (i === `prepayTransportFee`) {
            val = dataInput?.prepaidTransportAmount
        }
        if (i === `signedByUserId`) {
            val = dataInput?.signUserId
        }
        if (i === `signedByUserDisplay`) {
            val = dataInput?.signUserDisplay
        }
        if (i === `remark`) {
            val = dataInput?.remark
        }
        if (i === `paymentMethod`) {
            val = dataInput?.paymentType
        }
        if (i === `companyPurchaseNumber`) {
            val = dataInput?.purchaseNumber
        }
        if (i === `supplierPurchaseNumber`) {
            val = dataInput?.supplierPurchaseNumber
        }
        if (i === `checkinDateTime`) {
            val = dataInput?.checkinDateTime ? dataInput.checkinDateTime : dayjs().format("YYYY-MM-DD HH:mm:ss")
        }

        if (i === `barcode`) {
            val = barcode
        }

        if (i === `registerLocationId`) {
            val = locationId
        }
        if (i === `registerLocationDisplay`) {
            val = locationDisplay
        }

        if (i === `loadStatus`) {
            val = loadStatus !== "" ? loadStatus : productLoadStatusTypes.pending.value
        }
        if (i === `loadContainerId`) {
            val = loadContainerId === "" ? 0 : loadContainerId
        }
        if (i === `loadContainerDateTime`) {
            val = loadContainerDateTime === "" ? dayjs().format("YYYY-MM-DD HH:mm:ss") : loadContainerDateTime
        }

        if (i === `nfcPersonName`) {
            val = nfcInfo?.nfcPersonName ? nfcInfo.nfcPersonName : '-'
        }
        if (i === `nfcIdentityNo`) {
            val = nfcInfo?.nfcIdentityNo ? nfcInfo.nfcIdentityNo : '-'
        }
        if (i === `nfcFileId`) {
            val = nfcInfo?.nfcFileId ? nfcInfo.nfcFileId : 0
        }
        if (i === `nfcDetails`) {
            val = nfcInfo?.nfcDetails ? nfcInfo.nfcDetails : "{}"
        }

        if (i === `sourceProductRemId`) {
            val = sourceProductRemId
        }

        if (i === `appPrintPackQty`) {
            val = dataInput?.appPrintPackQty
        }
        if (i === `isAppEntry`) {
            val = dataInput?.isAppEntry
        }

        if (skipTargetInjectionFieldIds.includes(i) === false) {
            if (targetInjectionFieldIds.length > 0) { // if the target is defined

                // console.log('targetInjectionFieldIds', targetInjectionFieldIds, i)
                if (targetInjectionFieldIds.includes(i)) {
                    itemFields.push({
                        ..._def,
                        ref: `${item?.ref}`,
                        module: `${item?.module}`,
                        key: `${item?.submitKey}`,
                        value: `${val}`,
                        // field_key: `${item?.submitKey}`,
                        // field_value: `${val}`,
                        // props_key: item?.submitKey,
                        // props_field: item?.propFieldId,
                        // [item?.propFieldName]: val,
                        // is_multiple: 0,
                        ...schedulerRequests
                    })
                }

            } else { // loop all the props
                itemFields.push({
                    ..._def,

                    ref: `${item?.ref}`,
                    module: `${item?.module}`,
                    key: `${item?.submitKey}`,
                    value: `${val}`,

                    // field_key: `${item?.submitKey}`,
                    // field_value: `${val}`,
                    // props_key: item?.submitKey,
                    // props_field: item?.propFieldId,
                    // [item?.propFieldName]: val,
                    // is_multiple: 0,
                    ...schedulerRequests
                })
            }
        }


    })

    return itemFields

    // let dataInjectionFields = getUpdateFieldValuesPayload({
    //     items: itemFields
    // })

    // return dataInjectionFields

}

export const createProductItemInjectionFieldsPayload = ({
    itemId,
    sourceItemRemId = '',
    data,
    mainData,
    targetInjectionFieldIds = [], // only update the id
    skipTargetInjectionFieldIds = [], // skip to update the id
}) => {

    // console.log('data', data)

    let itemFields = []

    Object.keys(itemInjectionFields).forEach(i => {

        let item = itemInjectionFields[i]

        let _def = {
            refId: itemId,
        }

        let val = '';

        if (i === `customerMarking`) {
            val = mainData?.marking
        }
        if (i === `customerBranchId`) {
            val = mainData?.userBranchId
        }
        if (i === `customerUserId`) {
            val = mainData?.userId
        }
        if (i === `website`) {
            val = `0`
        }

        let dataInput = data?.input

        // if (i === `model`) {
        //     val = dataInput?.description ? dataInput.description : '-'
        // }
        if (i === `packQty`) {
            val = dataInput?.qty
        }
        if (i === `handleQty`) {
            val = dataInput?.handleQty
        }
        if (i === `qtyPerPackage`) {
            val = dataInput?.handleQtyPerPackage
        }
        if (i === `uomName`) {
            val = dataInput?.uomName
        }
        // if (i === `width`) {
        //     val = dataInput?.width
        // }
        // if (i === `length`) {
        //     val = dataInput?.length
        // }
        // if (i === `height`) {
        //     val = dataInput?.height
        // }
        if (i === `totalValue`) {
            val = dataInput?.totalValue
        }
        if (i === `totalCbm`) {
            val = dataInput?.totalCbm
        }
        if (i === `totalWeight`) {
            val = dataInput?.totalWeight
        }
        if (i === `containerId`) {
            val = `0`
        }
        if (i === `locationId`) {
            val = `0`
        }

        if (i === `sourceItemRemId`) {
            val = sourceItemRemId
        }

        if (skipTargetInjectionFieldIds.includes(i) === false) {

            if (targetInjectionFieldIds.length > 0) { // if the target is defined

                // console.log('targetInjectionFieldIds', targetInjectionFieldIds, i)
                if (targetInjectionFieldIds.includes(i)) {
                    itemFields.push({
                        ..._def,

                        ref: `${item?.ref}`,
                        module: `${item?.module}`,
                        key: `${item?.submitKey}`,
                        value: `${val}`,

                        // props_key: item?.submitKey,
                        // props_field: item?.propFieldId,
                        // [item?.propFieldName]: val,
                        // is_multiple: 0
                    })
                }

            } else { // loop all the props

                itemFields.push({
                    ..._def,

                    ref: `${item?.ref}`,
                    module: `${item?.module}`,
                    key: `${item?.submitKey}`,
                    value: `${val}`,

                    // props_key: item?.submitKey,
                    // props_field: item?.propFieldId,
                    // [item?.propFieldName]: val,
                    // is_multiple: 0
                })

            }
        }

    })

    return itemFields

    // let dataInjectionFields = getUpdateFieldValuesPayload({
    //     items: itemFields
    // })

    // return dataInjectionFields

}

export const createContainerInjectionFieldsPayload = ({
    containerId,
    data,
    targetInjectionFieldIds = [], // only update the id
    skipTargetInjectionFieldIds = [], // skip to update the id
}) => {

    // console.log('data', data)

    let itemFields = []

    Object.keys(containerInjectionFields).forEach(i => {

        let item = containerInjectionFields[i]

        let _def = {
            refId: containerId,
        }

        let val = '';

        if (i === `totalCbm`) {
            val = data?.totalCbm
        }
        if (i === `totalValue`) {
            val = data?.totalValue
        }
        if (i === `totalWeight`) {
            val = data?.totalWeight
        }
        if (i === `totalPackQty`) {
            val = data?.totalPackQty
        }

        if (skipTargetInjectionFieldIds.includes(i) === false) {
            if (targetInjectionFieldIds.length > 0) { // if the target is defined

                // console.log('targetInjectionFieldIds', targetInjectionFieldIds, i)
                if (targetInjectionFieldIds.includes(i)) {
                    itemFields.push({
                        ..._def,
                        ref: `${item?.ref}`,
                        module: `${item?.module}`,
                        key: `${item?.submitKey}`,
                        value: `${val}`,
                        // ...schedulerRequests
                    })
                }

            } else { // loop all the props
                itemFields.push({
                    ..._def,

                    ref: `${item?.ref}`,
                    module: `${item?.module}`,
                    key: `${item?.submitKey}`,
                    value: `${val}`,
                    // ...schedulerRequests
                })
            }
        }


    })

    return itemFields

    // let dataInjectionFields = getUpdateFieldValuesPayload({
    //     items: itemFields
    // })

    // return dataInjectionFields

}